// extracted by mini-css-extract-plugin
export default {"Emoji":"_21ReU4-kmWdEheg0AggGsf","icon":"_27k7MQv2nYuxj8lwkW9fEu"};